module.exports = __webpack_public_path__ + "static/media/disburse_report.e2e9031c.svg";